var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" mb--100"},[_c('div',{staticClass:"contact-form--1"},[_c('GoogleMaps',{staticClass:"class-z-index"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }